export enum USER_STATUS {
  ACTIVE = 'ACTIVE',
  UNVERIFY = 'UNVERIFY',
  LOCK = 'LOCK',
}

export enum USER_INVITE_STATUS {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  CANCELED = 'CANCELED',
}

export enum INVITATION_STATUS {
  CANCEL = 'cancel',
  RESEND = 'resend',
}
